import AmpEvents from '@amplify/amp-events';
import { getAppName, getEnvironmentName, getLrsEventData } from './lrsHelpers';

const AMPLIFY_HOME = 'https://mclass.amplify.com';
const APP_VERSION = '1.0.0';
const LANGUAGE = 'en-US';

export const initLRS = userId =>
    new AmpEvents({
        [AmpEvents.OPTIONS.APP_NAME]: 'mclass',
        [AmpEvents.OPTIONS.APP_VERSION]: APP_VERSION,
        [AmpEvents.OPTIONS.LANGUAGE]: LANGUAGE,
        [AmpEvents.OPTIONS.USER_ID]: userId,
        [AmpEvents.OPTIONS.ENVIRONMENT]: getEnvironmentName(),
    });

const triggerlrsTrackEvent = (verb, objectID, staffId, lrsTrackingInfo, sessionId) => {
    const lrsEventData = getLrsEventData(staffId, lrsTrackingInfo);

    const event = initLRS(lrsEventData.userId)
        .eventFactory.create()
        .addActorAccount('homePage', AMPLIFY_HOME)
        .addActorAccount('name', lrsEventData.userId)
        .addVerbId(verb)
        .addVerb('display', { 'en-US': verb })
        .addObject('id', objectID)
        .addContextExtension('page-url', window.location.href)
        .addContextExtension('host', window.location.host)
        .addContextExtension('app-version', APP_VERSION)
        .addContextExtension('application', getAppName())
        .addContextExtension('session-id', sessionId);
    Object.entries(lrsEventData.objectExtension).forEach(([key, value]) => {
        event.addContextExtension(key, value);
    });
    Object.entries(lrsEventData.resultExtension).forEach(([key, value]) => {
        event.addResultExtension(key, value);
    });
    return event.emit();
};

export const lrsEventOnAction = (verb, lrsObjectId, staffId, lrsTrackingInfo, sessionId) => {
    triggerlrsTrackEvent(verb, lrsObjectId, staffId, lrsTrackingInfo, sessionId);
};
